module.exports = __webpack_public_path__ + "img/stock4.01e7cbb8.png";